import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { RouterModule } from '@angular/router';
import { RangeInputComponent } from './components/range-input/range-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StepsComponent } from './components/steps/steps.component';
import { HeaderStepsComponent } from './components/header-steps/header-steps.component';
import { PlazoSelectorComponent } from './components/plazo-selector/plazo-selector.component';
import { CreditSimulatorComponent } from './components/credit-simulator/credit-simulator.component';
import { ImageHeaderHiveComponent } from './components/image-header-hive/image-header-hive.component';
import { GenericContentComponent } from './components/generic-content/generic-content.component';
import { EnterCodeComponent } from './components/enter-code/enter-code.component';
import { ConfirmModalComponent } from './components/modals/confirm-modal/confirm-modal.component';
import { BaseCardComponent } from './components/base-card/base-card.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BenefitModalComponent } from './components/modals/benefit-modal/benefit-modal.component';
import { WhatsappBtnComponent } from './components/whatsapp-btn/whatsapp-btn.component';
import { CallBtnComponent } from './components/call-btn/call-btn.component';
import { FooterComponent } from './components/footer/footer.component';
import { SocialMediaComponent } from './components/social-media/social-media.component';
import { StepsTutorialComponent } from './components/image-capture-tutorial/steps-tutorial.component';
import { DevBannerComponent } from './components/dev-banner/dev-banner.component';
import { PermissionsDeniedComponent } from './components/permissions-denied/permissions-denied.component';
import { DatalistComponent } from './components/datalist/datalist.component';
import { AddAddressComponent } from './components/add-address/add-address.component';
import { CardTrackingNumberComponent } from './components/card-tracking-number/card-tracking-number.component';
import { StepProcessComponent } from './components/step-process/step-process.component';
import { SimulatorContainerComponent } from './components/investment/simulator-container/simulator-container.component';
import { CreditOtpCodeComponent } from './components/otp/credit-otp-code/credit-otp-code.component';
import { InvestmentOtpCodeComponent } from './components/otp/investment-otp-code/investment-otp-code.component';
import { RedirectAppsComponent } from './components/modals/redirect-apps/redirect-apps.component';
import { ToolbarBaseComponent } from './components/toolbars/toolbar-base/toolbar-base.component';
import { FooterOneComponent } from './components/footers/footer-one/footer-one.component';
import { WaveComponent } from './components/waves/wave/wave.component';
import { AddressFormComponent } from './components/address/address-form/address-form.component';
import { DebounceClickDirective } from '../directives/debounce-click.directive';
import { AuthorizedCnbvComponent } from './components/utils/authorized-cnbv/authorized-cnbv.component';
import { ModalBaseComponent } from './components/modals/modal-base/modal-base.component';
import { MemberAgreementModalComponent } from './components/modals/member-agreement-modal/member-agreement-modal.component';
import { TrimOnBlurDirective } from 'src/app/directives/trim-on-blur.directive';
import { GetDebitCardModalComponent } from './components/modals/tdc/get-debit-card-modal/get-debit-card-modal.component';
import { TdcShipNoticeModalComponent } from './components/modals/tdc-ship-notice-modal/tdc-ship-notice-modal.component';
import { BtnDirective } from '../directives/buttons/btn.directive';
import { GoogleMapComponent } from './components/maps/google-map/google-map.component';
import { DevicePermissionModalComponent } from './components/modals/general/device-permission-modal/device-permission-modal.component';
import { LoaderComponent } from './components/utils/loadings/loader/loader.component';
import { LoaderMessageComponent } from './components/utils/loadings/loader-message/loader-message.component';
import { ErrorMessageComponent } from './components/forms/error-message/error-message.component';
import { OtpInputComponent } from './components/otp/otp-input/otp-input.component';
import { FullSizeLoadingComponent } from './components/utils/loadings/full-size-loading/full-size-loading.component';
import { SuccessMessageComponent } from './components/forms/success-message/success-message.component';
import { ConfirmDialogComponent } from './components/modals/basics/confirm-dialog/confirm-dialog.component';
import { ValidarPldModalComponent } from './components/modals/validar-pld-modal/validar-pld-modal.component';

@NgModule({
	declarations: [
		ToolbarComponent,
		RangeInputComponent,
		StepsComponent,
		HeaderStepsComponent,
		PlazoSelectorComponent,
		CreditSimulatorComponent,
		ImageHeaderHiveComponent,
		GenericContentComponent,
		EnterCodeComponent,
		ConfirmModalComponent,
		BaseCardComponent,
		PdfViewerComponent,
		BenefitModalComponent,
		WhatsappBtnComponent,
		CallBtnComponent,
		FooterComponent,
		SocialMediaComponent,
		StepsTutorialComponent,
		DevBannerComponent,
		PermissionsDeniedComponent,
		DatalistComponent,
		AddAddressComponent,
		CardTrackingNumberComponent,
		StepProcessComponent,
		SimulatorContainerComponent,
		CreditOtpCodeComponent,
		InvestmentOtpCodeComponent,
		RedirectAppsComponent,
		ToolbarBaseComponent,
		FooterOneComponent,
		WaveComponent,
		AddressFormComponent,
		DebounceClickDirective,
		AuthorizedCnbvComponent,
		ModalBaseComponent,
		MemberAgreementModalComponent,
		TrimOnBlurDirective,
		GetDebitCardModalComponent,
		TdcShipNoticeModalComponent,
		BtnDirective,
		GoogleMapComponent,
		DevicePermissionModalComponent,
		LoaderComponent,
		LoaderMessageComponent,
		ErrorMessageComponent,
		OtpInputComponent,
		FullSizeLoadingComponent,
		SuccessMessageComponent,
		ConfirmDialogComponent,
		ValidarPldModalComponent,
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		PdfViewerModule,
	],
	exports: [
		ToolbarComponent,
		RangeInputComponent,
		StepsComponent,
		HeaderStepsComponent,
		PlazoSelectorComponent,
		CreditSimulatorComponent,
		ImageHeaderHiveComponent,
		GenericContentComponent,
		EnterCodeComponent,
		ConfirmModalComponent,
		BaseCardComponent,
		PdfViewerComponent,
		BenefitModalComponent,
		WhatsappBtnComponent,
		CallBtnComponent,
		FooterComponent,
		SocialMediaComponent,
		StepsTutorialComponent,
		PermissionsDeniedComponent,
		DevBannerComponent,
		DatalistComponent,
		AddAddressComponent,
		CardTrackingNumberComponent,
		StepProcessComponent,
		SimulatorContainerComponent,
		CreditOtpCodeComponent,
		InvestmentOtpCodeComponent,
		WaveComponent,
		RedirectAppsComponent,
		ToolbarBaseComponent,
		FooterOneComponent,
		AddressFormComponent,
		DebounceClickDirective,
		AuthorizedCnbvComponent,
		ModalBaseComponent,
		MemberAgreementModalComponent,
		TrimOnBlurDirective,
		GetDebitCardModalComponent,
		TdcShipNoticeModalComponent,
		BtnDirective,
		GoogleMapComponent,
		DevicePermissionModalComponent,
		LoaderComponent,
		LoaderMessageComponent,
		ErrorMessageComponent,
		OtpInputComponent,
		FullSizeLoadingComponent,
		SuccessMessageComponent,
		ConfirmDialogComponent,
		ValidarPldModalComponent,
	],
})
export class SharedModule {}
